import React, { useEffect, useState } from "react";
import { Container } from "../ui/Container";
import { IntegrationsCreateBanner } from "./integrationsCreateBanner";
import { makeStyles } from "@mui/styles";
import { IntegrationListWrapper } from "./IntegrationListWrapper";
import { IntegrationItemProps } from "../../api/integrations/IntegrationsDTO";
import { useIntegrationsContext } from "../../api/integrations/IntegrationsContext";
import { Loader } from "../ui/Loader";
import { showError } from "../../utils/NotificationUtils";
import jwtDecode from "jwt-decode";
import Cookies from "js-cookie";

const useStyles = makeStyles(() => ({
    root: {
        padding: 24,
    },
}));

export function IntegrationsListing() {
    const classes = useStyles();
    const token = Cookies.get("token");
    const { IntegrationsApi } = useIntegrationsContext();
    const [list, setList] = useState<IntegrationItemProps[]>([]);
    const [searchValue, setSearchValue] = useState("");
    const [loaded, setLoaded] = useState(false);
    //@ts-ignore
    const {userId} = jwtDecode(token ?? "");
    useEffect(() => {
        IntegrationsApi.getIntegrationsList()
            .then((res) => {
                setList(res.payload.list);
                setLoaded(true);
            })
            .catch((err) => {
                setLoaded(false);
                showError(err);
            });
    }, [IntegrationsApi, searchValue]);


    return (
        <div className={classes.root}>
            <Container>
                <IntegrationsCreateBanner />
                {loaded ? (
                    list?.length > 0 ? (
                        <IntegrationListWrapper
                            data={list.filter((item) =>
                                item.name.toLowerCase().includes(searchValue.toLowerCase()) && item.ownerId === userId
                            )}
                            onSearch={(searchValue) => setSearchValue(searchValue)}
                        />
                    ) : (
                        <h2>Empty</h2>
                    )
                ) : (
                    <Loader size={50} />
                )}
            </Container>
        </div>
    );
}
